import { PricingType } from "@/types/app/ooc/pricing.type";
import { PriceInterface } from "@/interface/business/item.interface";
import { PriceMoney } from "@/modules/location";
import { PricingInterface } from "@/interface/app/ooc/menu.interface";

export class Pricing implements PricingInterface {
  id: string = "";
  location_id: string = "";
  original_price: number = 0;
  original_price_display: string = "0.000";
  price: number | string = 0;
  cost: number = 0;
  has_inventory_cost: boolean = true;
  available: boolean = false;
  price_money?: PriceInterface;

  constructor(data?: PricingType) {
    if (data) {
      this.id = data.id || "";
      this.location_id = data.location_id || "";
      this.price = data.price || 0;
      this.cost = data.cost || 0;
      this.has_inventory_cost = data.has_inventory_cost || true;
      this.available = data.available || false;
      this.price_money = new PriceMoney({ amount: data.price || 0 });
      this.preparePrice(data);
    }
  }

  /**
   * prepare display price and original price to be displayed
   * @param data
   * @private
   */
  private preparePrice(data) {
    this.original_price = data.original_price ?? this?.price_money?.amount ?? 0;
    this.original_price_display = data.original_price
      ? new PriceMoney({ amount: data?.original_price }).getPricePackage()
      : this?.price_money?.getPricePackage() ?? "0:00";
  }

  /**
   *will set the price money , will convert the price to 0 if the input is not a number
   * @return void
   */
  public setPriceMoney(): void {
    this.price_money = new PriceMoney({ amount: +this.price || 0 });
  }
}
